// Глобальное определение JQuery для inline скриптов.
// Пример подключения:
// <% append_javascript_pack_tag 'jquery_global', defer: false %>
import $ from 'jquery';
window.$ = window.jQuery = $;
